import React from "react";
import Select from "react-select";
import { getCustomStylesMultiSelect } from "./CustomSelectInput";
import { useTheme as styledTheme } from "styled-components";

interface CustomSelectProps {
  inputId: string;
  value?: any; // Adjust based on the type of value you expect
  onChange?: (selectedOption: any) => void; // Adjust type if needed
  placeholder: string;
  options: Array<{ label: string; value: string }>; // Adjust based on your options type
}

export const CustomSelect: React.FC<CustomSelectProps> = ({
  inputId,
  value,
  onChange,
  placeholder,
  options,
}) => {
    const styledComponentTheme = styledTheme();
  return (
    <Select
      inputId={inputId}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      styles={getCustomStylesMultiSelect(styledComponentTheme, false, {
        control: (provided, state) => ({
          ...provided,
          backgroundColor: state.isFocused
            ? styledComponentTheme.searchInputBcgClrHver
            : styledComponentTheme.searchInputBcg,
          borderRadius: "25px",
          borderWidth: "1px",
          boxShadow: "none",
          borderColor: state.isFocused
            ? styledComponentTheme.text
            : styledComponentTheme.searchInputBdrClr,
          "&:hover": {
            borderColor: styledComponentTheme.searchInputBdrClrHver,
            backgroundColor: styledComponentTheme.searchInputBcgClrHver,
          },
        }),
      })}
      isSearchable={false}
      isMulti
      menuPortalTarget={document.body}
      menuPosition="fixed"
      menuPlacement="auto" // Adjust dropdown placement dynamically
    />
  );
};
